module.exports = __webpack_public_path__ + "static/media/icon-must-fillin.f8000fc6.svg";